import { render, staticRenderFns } from "./AssumptionsBuildingStocksInput.vue?vue&type=template&id=2b70701c&scoped=true&"
import script from "./AssumptionsBuildingStocksInput.vue?vue&type=script&lang=js&"
export * from "./AssumptionsBuildingStocksInput.vue?vue&type=script&lang=js&"
import style0 from "./AssumptionsBuildingStocksInput.vue?vue&type=style&index=0&id=2b70701c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b70701c",
  null
  
)

export default component.exports